import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { MapPin, Home, Navigation } from 'lucide-react';

function Directions() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b py-6 px-4">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <h1 className="text-3xl font-bold">Directions to Defiance Springs</h1>
          <a href="/">
            <Button 
              className="bg-black text-white hover:bg-black/90"
              style={{ borderRadius: 0 }}
            >
              <Home className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </a>
        </div>
      </header>

      <main className="py-12 px-4">
        <div className="max-w-4xl mx-auto space-y-8">
          <Card style={{ borderRadius: 0 }}>
            <CardHeader>
              <CardTitle className="text-2xl flex items-center gap-3">
                <MapPin className="w-6 h-6" />
                Defiance Springs
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div>
                <p className="text-xl font-semibold mb-2">Viroqua, Wisconsin</p>
                <p className="text-lg text-gray-700">110-acre regenerative community</p>
              </div>

              <div className="space-y-4">
                <p className="text-lg font-semibold">Get Directions:</p>
                <a 
                  href="https://maps.app.goo.gl/cNKeBNBQ3oGZvF3Z7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <Button 
                    className="w-full bg-blue-600 text-white hover:bg-blue-700 py-6 text-xl"
                    style={{ borderRadius: 0 }}
                  >
                    <Navigation className="w-5 h-5 mr-3" />
                    Open in Google Maps
                  </Button>
                </a>
                <p className="text-sm text-gray-600 text-center">
                  Opens in Google Maps app on mobile or new tab on desktop
                </p>
              </div>

              {/* Map Image */}
              <div className="mt-8">
                <img 
                  src="https://customer-assets.emergentagent.com/job_belonging-sessions/artifacts/3l7kv8dj_94hsvcqm_Image%208-4-25%20at%202.45%E2%80%AFAM.jpeg"
                  alt="Directions to Defiance Springs Lodge"
                  className="w-full border-2 border-gray-300 rounded-sm shadow-lg"
                />
                <p className="text-center text-sm text-gray-600 mt-3">
                  <strong>E6801 Dustin Rd, Viroqua, WI</strong> | Need help? Call 608-632-1347
                </p>
              </div>

              <div className="mt-8 p-6 bg-gray-50 border-l-4 border-black">
                <h3 className="text-xl font-bold mb-3">What to Expect</h3>
                <div className="space-y-2 text-base text-gray-700">
                  <p>• <strong>Parking:</strong> Available on-site</p>
                  <p>• <strong>Accessibility:</strong> Please contact us if you have specific needs</p>
                  <p>• <strong>What to Bring:</strong> Open heart, willingness to connect</p>
                  <p>• <strong>Questions?</strong> Email hello@defiancesprings.com</p>
                </div>
              </div>

              <div className="mt-8 text-center">
                <a href="/">
                  <Button 
                    variant="outline"
                    className="border-black px-8 py-4 text-lg"
                    style={{ borderRadius: 0 }}
                  >
                    Return to The Belonging Sessions
                  </Button>
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}

export default Directions;
